const apiUrl = "https://api.redea.io";
export default apiUrl;